/**
 * Application entry point. Mounts the React component tree into the DOM,
 * wrapping it with the Redux store provider, React Router, and the alert context.
 *
 * @module index
 * @author Snowfly
 * @version 1.0.0
 */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import './assets/fonts/fonts.css';
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './App';
import {AlertProvider} from "./components/common/AlertContext";

/**
 * Global flag indicating whether the application is running outside production.
 * Available on `window` for use by non-module scripts.
 *
 * @type {boolean}
 */
window.IS_DEVELOPMENT = (process.env.REACT_APP_STAGE !== 'prod');

ReactDOM.render(
    <BrowserRouter>
        <Provider store={store}>
            <AlertProvider>
                <App />
            </AlertProvider>
        </Provider>
    </BrowserRouter>,
    document.getElementById('root'),
);
